/**
 * React dependencies
 */

import React from 'react';

/**
 * DWT Dependencies
 */

const FilterInfo = ({ filterByOptionsFromParent, filterByFromParent }) => {
  const label = filterByOptionsFromParent?.map( ( option ) => {
    if ( filterByFromParent === option.value ) {
      return option.label;
    }
  });

  const filtered = label?.filter( ( item ) => item !== undefined );

  return (
    <div className='list-info'>
      <h4 className='heading-4 mt-0 mb-0 w-full'>{ filtered?.toString() }</h4>
    </div>

  );
};

export default FilterInfo;
